import { PRIMARY_COLOR } from '../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../theme/fontConstants';

export const rootGridStyles = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  borderRadius: '20px',
  overflow: 'hidden',
  minHeight: 329,
  width: 650,
  outline: 'none',
  backgroundColor: 'white',
  paddingTop: 5,
  paddingBottom: 5,
  paddingLeft: 7,
  paddingRight: 7,
};

export const modalTitleStyles = {
  fontFamily: PRIMARY_FONT[700],
  fontSize: '32px',
  lineHeight: '24px',
  color: PRIMARY_COLOR[70],
  marginBottom: 2,
};

export const modalBodyContentStyle = {
  fontFamily: PRIMARY_FONT[400],
  fontSize: '16px',
  lineHeight: '24px',
  color: '#000000',
};

export const modalBodyTimeContentStyle = {
  fontFamily: PRIMARY_FONT[300],
  fontSize: '16px',
  lineHeight: '24px',
  color: '#000000',
  marginBottom: 1,
};
